import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { ClinicalWaitingListItem } from "./ClinicalWaitingListItem";

class ClinicalWaitingListTableItem implements ITableDataSourceItem<ClinicalWaitingListItem> {
    public Name: string;
    public Model: ClinicalWaitingListItem;

    constructor(model: ClinicalWaitingListItem) {
        this.Model = model;
    }
}

export { ClinicalWaitingListTableItem };
